<template>
  <div class="rstl_container">
    <transition
      name="slide-in-out"
      mode="out-in"
    >
      <div
        v-show="show"
        class="result-tile rstl"
        :data-tst="show ? `${tstPrefix}_quickres_tile` : ''"
        :style="cssStyle"
      >
        <slot>
          <i
            v-if="correctness_group.icon"
            class="mdi rstl_icon"
            :class="[correctness_group.res_group, correctness_group.icon]"
          />
          <div class="text-nowrap">
            <!-- <span v-if="hasResultName">
              {{ $t(`practice.${correctness_group.res_id}`) }}
            </span> -->
            <!-- <span v-else class="rstl_action"> -->
            <span class="rstl_action">
              {{ l_action.display_name }}
              <span
                class="pl-1"
                v-html="getBetHtml({ showBetsIn, a: l_action })"
              ></span>
            </span>
          </div>
          <div
            v-if="correctness_group.res_id !== 'na' && !hasResultName"
            class="rstl_frequecy text-nowrap ml-2"
          >
            {{ numFixedUnit(l_action.frequency * 100, 'strategy') }}%
          </div>
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'

export default {
  name: 'ResultTile',
  mixins: [format_mix],
  props: {
    show: Boolean,
    action: Object,
    hasFrequency: Boolean,
    hasResultName: Boolean,
    tstPrefix: {
      type: String,
      default: 'trainer',
    },
  },
  computed: {
    l_action() {
      return this.action || {}
    },
    correctness_group() {
      return this.l_action?.correctness_group || {}
    },
    cssStyle() {
      const res = {
        '--clr': `var(${this.correctness_group.color})`,
      }
      // console.log(res, this.l_action)
      return res
    },
    showBetsIn() {
      const { show_bets_in } = this.$store.getters
      return show_bets_in
    },
  },
}
</script>
<style lang="scss" scoped>
// @media (max-width: 1023px) {
//   .rstl {
//     bottom: 9.6em !important;
//   }
// }
.rstl {
  &_container {
    --height: 3.25em;
    min-height: var(--height);
    max-height: var(--height);
    flex: 1;
    // background: rgb(24, 24, 24);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  // flex: 1;
  min-width: 14em;
  // margin: auto;
  padding: 0 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border: solid 2px var(--clr-black-3);
  background: var(--clr-black-0);
  font-size: 1em;
  height: var(--height);
  border-radius: 99em;
  flex-shrink: 0;
  font-weight: 700;
  flex-shrink: 0;
  --clr: var(--clr-white-0);
  &_action {
    text-transform: uppercase;
  }
  &_icon {
    color: var(--clr);
    font-size: 2em;
    margin: 0 1em 0 0;
  }
}
</style>
